'use strict';
/**
 * Registration Constants.
 */
const RegistrationConstants = {
    /**
     * Action codes for resolving section issues.
     */
    PrimarySectionActionCodes: {
        REMOVE_ALL_BUT_ONE_SECTION: "REMOVE_ALL_BUT_ONE_SECTION",
        REMOVE_ALL_BUT_ONE_REQUIRED_SECTION: "REMOVE_ALL_BUT_ONE_REQUIRED_SECTION",
        CHECK_WITH_DEPARTMENT:"CHECK_WITH_DEPARTMENT"
    }
};
export default RegistrationConstants;